module.exports = __webpack_public_path__ + "img/formulas_2.b1641fbf.svg";